import { prepareIncomeSourcePayload } from "./utils";

import type { IncomeReportingFormValues, IncomeSourcePayload } from "./types";
import type { NetworkPayload } from "../../../composites";

export const API = {
  createIncomeSource: (
    formData: IncomeReportingFormValues,
  ): NetworkPayload<IncomeSourcePayload> => {
    return {
      url: "income_source",
      options: {
        method: "POST",
        payload: prepareIncomeSourcePayload(formData),
        isJsonResponse: true,
      },
    };
  },
  editIncomeSource: (
    formData: IncomeReportingFormValues,
    uuid: string,
  ): NetworkPayload<IncomeSourcePayload> => {
    return {
      url: `income_source/${uuid}`,
      options: {
        method: "PUT",
        payload: prepareIncomeSourcePayload(formData),
        isJsonResponse: true,
      },
    };
  },
};
